// Lib
import React, { ReactElement } from 'react';

// Selectors
import { selectIsMarkActive } from './selectors/tiptapToolSelectors';

// Hooks
import {
    useActiveTiptapEditorTouchCallback,
    useTiptapActiveEditorSelector,
} from '../../../../../components/tiptapEditor/store/tiptapEditorStoreHooks';

// Components
import RichTextTool from './RichTextTool';

// Types
import { ToolbarToolProps } from '../../../config/toolDefinitions/toolbarToolTypes';

type StandardTiptapMarkToolProps = ToolbarToolProps & {
    mark: string;
};

const TiptapToggleMarkTool = (props: StandardTiptapMarkToolProps): ReactElement => {
    const { mark } = props;

    const isActive = useTiptapActiveEditorSelector(selectIsMarkActive(mark));

    const toggleMark = useActiveTiptapEditorTouchCallback(
        (activeEditor, event) => {
            event?.preventDefault();
            activeEditor.commands.toggleMark(mark);
        },
        [mark],
    );

    return (
        <RichTextTool isActive={isActive} onClick={toggleMark} iconName={props.iconName || 'toolbar-bold'} {...props} />
    );
};

export default TiptapToggleMarkTool;
